import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import s from "./styles.module.scss";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navigateToTerms = () => navigate("/terms-of-service");
  const navigateToPolicy = () => navigate("/privacy-policy");

  return (
    <footer className={s.footer}>
      <p style={{ cursor: "default" }}>
        Copyright © 2026 Ocean. All rights reserved
      </p>
      <div className={s.footerLinks}>
        <span
          onClick={navigateToPolicy}
          className={`${s.link} ${
            location.pathname === "/privacy-policy" ? s.activeLink : ""
          }`}
        >
          Privacy Policy
        </span>
        <span
          onClick={navigateToTerms}
          className={`${s.link} ${
            location.pathname === "/terms-of-service" ? s.activeLink : ""
          }`}
        >
          Terms of Service
        </span>
        <a className={s.link} href="mailto:max@oceanwebapp.com">
          Contact us
        </a>
      </div>
    </footer>
  );
};

export default Footer;
